import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María', 'Camila', 'Valentina', 'Sofía', 'Florencia', 'Agustina', 'Luciana', 'Daniela', 'Paula', 'Andrea', 'Romina', 'Celeste', 'Milagros', 'Julieta', 'Antonella'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      // Pick random name and city
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (between 8 and 12 seconds from now)
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextDelay);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    return () => {
      clearTimeout(initialTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-256">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white border-l-4 border-green-500 shadow-2xl rounded-r-lg p-4 flex items-center gap-3" data-id="element-257">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-258">
            <span className="text-xl" data-id="element-259">🔥</span>
          </div>
          <div data-id="element-260">
            <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-261">
              <span className="font-bold" data-id="element-262">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city} acaba de comprar MUJER DE ALTO VALOR
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-263">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}